import React, { useContext } from 'react';
import { observer } from 'mobx-react-lite';
import { Typography } from '@mui/material';
import { UiContext } from 'shared/lib/contexts/uiContext';

export default observer(function TableHeaderItem({
  children,
}: {
  children: React.ReactNode;
}) {
  const {
    spacings: { sp },
  } = useContext(UiContext);

  return (
    <Typography
      sx={{ p: sp.s30, display: 'flex' }}
      variant="f12"
      color="text.secondary"
    >
      {children}
    </Typography>
  );
});
